export default "__VITE_ASSET__B6kH$a7___"